<template>
  <div class="app-container-page">
    <div class="navbar" :style="{ 'padding-top': paddingTop + 'px'}" :class="{ios:isIOS}">
      <div class="navbar-back" @click="closeWebview"></div>
      <div class="navbar-title">默往币充值协议</div>
      <div class="navbar-menu"></div>
    </div>

    <iframe src="/mwrecharge" :style="{'padding-top': `calc(1.33333rem + ${paddingTop}px )`}"
            :class="{ios:isIOS}"></iframe>

  </div>
</template>

<script>
import NativeBridge from '@/utils/NativeBridge'

export default {
  name: 'Agreement',
  data () {
    return {
      paddingTop: window.$paddingTop || 0,
      isIOS: !!window.webkit,
      nativeBridge: new NativeBridge()
    }
  },
  methods: {
    closeWebview () {
      if (this.isIOS) {
        this.$router.replace('/coin/recharge')
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/style.scss";

.app-container-page {
  font-size: px2rem(32);
  width: 100%;
  height: 100vh;
  overflow-y: auto;

  .navbar {
    width: 100%;
    height: px2rem(100);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000;
    font-size: px2rem(32);
    position: fixed;
    top: 0;
    z-index: 9;
    background: #fff;
    font-weight: bold;

    &.ios {
      //padding-top: 44px!important;
      padding-top: constant(safe-area-inset-top, 44px) !important;
      padding-top: env(safe-area-inset-top, 44px) !important;
    }

    .navbar-back {
      width: px2rem(100);
      height: px2rem(100);
      background-image: url("../../assets/image/invite/back_black.svg");
      background-repeat: no-repeat;
      background-position: center;
    }

    .navbar-menu {
      width: px2rem(100);
      height: px2rem(100);
      display: flex;
      align-items: center;
      font-size: px2rem(30);
    }
  }

  iframe {
    position: relative;
    z-index: 1;
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    border: 0;
    outline: none;

    &.ios {
      padding-top: calc(1.33333rem + constant(safe-area-inset-top)) !important;
      padding-top: calc(1.33333rem + env(safe-area-inset-top)) !important;
    }
  }
}
</style>
